import { defineComponent as _defineComponent } from 'vue'
import CryptoJS from 'crypto-js'
import EditableBlock from '@/components/EditableBlock.vue'
import EditableBlockInput from '@/components/EditableBlockInput.vue'
import DButton from '@/components/base/DButton.vue'
import { ref } from 'vue'
import { useStore } from 'vuex'
import { useQuasar } from 'quasar'
import Clipable from '@/components/Clipable.vue'
import type { CtSupplier } from '@/models/interfaces/content-type'

const TOKEN_PRE = 'OZNST'

export default /*@__PURE__*/_defineComponent({
  __name: 'SupplierApiSettings',
  props: {
    supplier: {}
  },
  emits: ["update:supplier"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props

const emits = __emit

const $store = useStore()
const $q = useQuasar()
const $directr = $store.getters['Services/Directr']

const showToken = ref(false)

async function deleteToken (supplierId) {
  const data = { token: { cleared: Date.now() } }
  const patched = await $directr.patch('supplier', supplierId, data)
  showToken.value = false
  $q.notify({ type: 'positive', message: 'Api token deleted' })
  emits('update:supplier', supplierId, data)
}

async function generateToken (supplierId) {
  const access_token = `${TOKEN_PRE}-${CryptoJS.SHA256(String(Math.round(Math.random())+Date.now()))}`

  const data = { token: { access_token } }
  const patched = await $directr.patch('supplier', supplierId, data)

  showToken.value = true
  $q.notify({ type: 'positive', message: 'Api token generated & saved' })

  emits('update:supplier', supplierId, data)
}

const __returned__ = { TOKEN_PRE, props, emits, $store, $q, $directr, showToken, deleteToken, generateToken, get CryptoJS() { return CryptoJS }, EditableBlock, EditableBlockInput, DButton, ref, get useStore() { return useStore }, get useQuasar() { return useQuasar }, Clipable }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})